import React from 'react';
import Layout from '../../../components/common/pageLayout';
import Form from '../../../components/MasterData/ScheduleCategory/add';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { v3_add_schedule_category } from '../../../actions/v3/masterData';

const AddCategory = (props) => {
    const onSubmit = (model) => {
        v3_add_schedule_category(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.listScheduleCategoryMasterData.url);
            } else {
                toast.error(res.error);
            }
        });
    };

    return (
        <React.Fragment>
            <Layout title="Add Category">
                <Form
                    title="Add Category"
                    onSubmit={onSubmit}
                    buttonName="Create Category"
                />
            </Layout>
        </React.Fragment>
    );
};

export default AddCategory;
